var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum2BlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2227,
    cy: 16.916,
    r: 15.5,
    stroke: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4512 22.916V21.641C15.4662 18.941 17.2512 16.856 17.2512 15.146C17.2512 14.021 16.6512 13.346 15.5862 13.346C14.7762 13.346 14.1162 13.871 13.5462 14.486L12.3462 13.286C13.3662 12.191 14.3562 11.606 15.8712 11.606C17.9712 11.606 19.3662 12.956 19.3662 15.026C19.3662 17.036 17.7012 19.196 15.6762 21.176C16.2312 21.116 16.9662 21.056 17.4912 21.056H19.8912V22.916H12.4512Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum2BlueBorder);
export default __webpack_public_path__ + "static/media/icon_circleNum_2_blueBorder.5369c97f5c0aa60c487aa9357c0db4d9.svg";
export { ForwardRef as ReactComponent };